
import * as api from "../constant/NewAPI";
import React, { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Link } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../router/all_routes";
import * as XLSX from "xlsx";
import Utils from "../constant/Utils";

// import * as api from "../constant/API";

const InstituteStatusReport = () => {

    const routes = all_routes;

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState('');
    const [groupId, setGroupId] = useState('');
    const [institutionId, setInstitutionId] = useState('');
    const [groupList, setGroupList] = useState([]);
    const [instituteList, setInstituteList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [linkClicked, setLinkClicked] = useState(false);

    useEffect(() => {
        instituteTypeList();
    }, []);

    function instituteTypeList() {
        const instTypeList = api.InstituteTypeList + '/' + roleId //+ "?userId=" + userId + "&roleId=" + roleId;
        fetch(instTypeList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((typResponse) => typResponse.json())
            .then((typResult) => {
                if (typResult.error == true) {
                    if (typResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (typResult.data != null) {
                        setGroupList(typResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log('Failed to fetch Institute Type List', error);
            })
    }

    function getInstitutes(grpId) {
        const institute = api.GetReportInstitutions + '/' + roleId + '/' + grpId //"?institutionTypeId=" + grpId + "&userId=" + userId + "&roleId=" + roleId;
        fetch(institute, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instReponse) => instReponse.json())
            .then((instResult) => {
                if (instResult.error == true) {
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (instResult.data != null) {
                        setInstituteList(instResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error)
            })
    }

    function statusReport() {
        const statReport = api.GetStatusReport + '/' + groupId + '/' + fromDate + '/' + toDate + '/' + institutionId //"?instTypeId=" + groupId + "&instName=" + institutionId + "&formDate=" + fromDate + "&toDate=" + toDate;
        fetch(statReport, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((statResponse) => statResponse.json())
            .then((statResult) => {
                if (statResult.error == true) {
                    if (statResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (statResult.error == false && statResult.data != null) {
                        setStatusList(statResult.data);
                    }
                    setShowTable(true)
                    setLinkClicked(true)
                }
            })
            .catch((error) => {
                console.log('Failed to fetch status report.', error)
            })
    }

    const filteredData = statusList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const dateRender = (rowData, column) => {
        return <span>{formatDate(rowData.scheduleDate)}</span>
    };

    const timingRender = (rowData, column) => {
        return <span>{rowData.classTime}</span>
    };
    const scdlTypRender = (rowData, column) => {
        return <span>{rowData.schedulesName}</span>
    };

    const sportRender = (rowData, column) => {
        return <span>{rowData.sportName}</span>
    };

    const coachRender = (rowData, column) => {
        return <span>{rowData.coachName}</span>
    };

    const skillRender = (rowData, column) => {
        return <span>{rowData.SkillName}</span>
    };

    const commentRender = (rowData, column) => {
        return <span>{rowData.scheduleComments}</span>
    };

    const exportToExcel = () => {
        const formData = new FormData();

        formData.append('instituteTypeId', groupId)
        formData.append('institutionId', institutionId)
        formData.append('fromDate', fromDate)
        formData.append('toDate', toDate)
        const exportExcel = api.InstitutionStatusExport;
        fetch(exportExcel, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((exportReponse) => exportReponse.json())
            .then((exportResult) => {
                if (exportResult.error == true) {
                    if (exportResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    const blob = new Blob([exportResult.data], { type: "application/vnd.ms-excel" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "InstituteStatusReport.xls"; // Save file as .xls
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                console.log("Failed to export Institute Status Report", error);
            })
    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Institute Status Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-secondary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">
                                                                    <div className="col-lg-4 mb-10">
                                                                        <label className="sortbytitle"><h6>Institute Group</h6></label>
                                                                        <Select
                                                                            value={groupList.find(grp => grp.institutionGroupId === groupId) ? {
                                                                                value: groupId,
                                                                                label: groupList.find(grp => grp.institutionGroupId === groupId).institutionGroupName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setGroupId(e.value);
                                                                                getInstitutes(e.value)
                                                                            }}
                                                                            options={groupList.map(grp => ({
                                                                                value: grp.institutionGroupId,
                                                                                label: grp.institutionGroupName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                    <div className="col-lg-4 mb-10">
                                                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                                                        <Select value={instituteList.find(inst => inst.institutionId === institutionId) ? {
                                                                            value: institutionId,
                                                                            label: instituteList.find(inst => inst.institutionId === institutionId).institutionName
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setInstitutionId(e.value)
                                                                            }}
                                                                            options={instituteList.map(inst => ({
                                                                                value: inst.institutionId,
                                                                                label: inst.institutionName
                                                                            }))}
                                                                            placeholder={"Select Institute"}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-2 mb-10">
                                                                        <label className="sortbytitle"><h6>From Date</h6></label>
                                                                        <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={fromDate} onChange={(e) => setFromDate(e.target.value)}></input>
                                                                    </div>
                                                                    <div className="col-lg-2 mb-10">
                                                                        <label className="sortbytitle"><h6>To Date</h6></label>
                                                                        <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={toDate} onChange={(e) => setToDate(e.target.value)}></input>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row col-lg-12">
                                                                <div className="save-changes text-sm-end mt-2">
                                                                    <Link
                                                                        to="#"
                                                                        className="btn btn-secondary save-profile"
                                                                        onClick={statusReport}
                                                                    >
                                                                        Submit
                                                                    </Link>
                                                                    <Link
                                                                        to="#"
                                                                        className="btn btn-secondary save-profile"
                                                                        onClick={exportToExcel}
                                                                    >
                                                                        Export to Excel
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                            {showTable && (
                                                                <>
                                                                    <div className="col-md-12">
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="dataTables_filter">
                                                                            <label>
                                                                                <input
                                                                                    type="text"
                                                                                    value={searchInput}
                                                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                                                    placeholder="Search"
                                                                                    className="form-control"
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {showTable && (
                                                        <>
                                                            <div className="tab-content">
                                                                <div
                                                                    className="tab-pane fade show active"
                                                                    id="nav-Recent"
                                                                    role="tabpanel"
                                                                    aria-labelledby="nav-Recent-tab"
                                                                    tabIndex={0}
                                                                >
                                                                    <div className="table-responsive table-datatble">
                                                                        <DataTable
                                                                            className="table datatable"
                                                                            value={filteredData}
                                                                            paginator
                                                                            rows={10}
                                                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                            pageLinkSize={3}
                                                                        >
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="slNo"
                                                                                body={slNoRender}
                                                                                header="Sl No"
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="scheduleDate"
                                                                                body={dateRender}
                                                                                header="Date"
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="classTime"
                                                                                body={timingRender}
                                                                                header="Class Timing"
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="schedulesName"
                                                                                body={scdlTypRender}
                                                                                header="Schedule Type"
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="sportName"
                                                                                body={sportRender}
                                                                                header="Sport"
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="coachName"
                                                                                body={coachRender}
                                                                                header="Coach"
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="SkillName"
                                                                                body={skillRender}
                                                                                header="Skill taught"
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="scheduleComment"
                                                                                body={commentRender}
                                                                                header="Schedule Comment"
                                                                            ></Column>
                                                                        </DataTable>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div >
        </>
    );
};

export default InstituteStatusReport;